import { useCallback } from 'react';
import { NavigateOptions, useNavigate } from 'react-router-dom';
import { createAppPathAndPersistQuery } from '../../utils/router';

/** returns in-app version of {@link useNavigate} that persists the current
 * search param and accepts a string instead of a `Partial<Path>` */
export default function useInAppNavigate() {
  const navigate = useNavigate();
  return useCallback(
    (to: string, options?: NavigateOptions) => navigate(createAppPathAndPersistQuery(to), options),
    [],
  );
}
